import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import Format from '../../../Services/Format';
import { HourTotal } from '../useSalesAnalytics';
import * as S from './styles';

const compactCurrency = (value: number) => {
  if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M`;
  if (value >= 1_000) return `${(value / 1_000).toFixed(0)}mil`;
  return String(Math.round(value));
};

function HourTooltip({ active, payload, label }: any) {
  if (!active || !payload?.length) return null;
  const point = payload[0]?.payload;

  return (
    <S.TooltipCard>
      <span className="hour">{label}</span>
      <span>{Format.formatCurrencyBr(point?.total)}</span>
      <span>
        {point?.orders} pedido{Number(point?.orders) === 1 ? '' : 's'}
      </span>
    </S.TooltipCard>
  );
}

export function SalesByHour({
  hours,
  isFetching,
  errorMessage,
}: {
  hours: HourTotal[];
  isFetching?: boolean;
  errorMessage?: string | null;
}) {
  const hasSales = hours.some((hour) => hour.total > 0);

  return (
    <S.Container>
      {/*
        O backend agrupa pela hora de `created_at` (abertura da venda), não pela
        de fechamento: `sales.close_date` é DATE, sem componente de hora, então
        a hora de fechamento nunca foi gravada. Se o cliente exigir a hora real
        de fechamento, é preciso pedir a coluna `closed_at` ao backend.
      */}
      <h3>Vendas por Horário do Dia</h3>

      {hasSales ? (
        <div className="chart">
          <ResponsiveContainer width="100%" height={260}>
            <BarChart data={hours} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
              <CartesianGrid vertical={false} strokeDasharray="4 8" stroke="#EEF0F5" />

              <XAxis
                dataKey="label"
                stroke="#9CA3AF"
                tickLine={false}
                axisLine={false}
                tick={{ fontSize: 11, fill: '#6B7280' }}
                interval={1}
              />

              <YAxis
                stroke="#9CA3AF"
                tickLine={false}
                axisLine={false}
                tick={{ fontSize: 11, fill: '#6B7280' }}
                width={56}
                tickFormatter={compactCurrency}
              />

              <Tooltip
                cursor={{ fill: 'rgba(79, 70, 229, 0.08)' }}
                content={<HourTooltip />}
              />

              <Bar dataKey="total" fill="#4F46E5" radius={[4, 4, 0, 0]} maxBarSize={28} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      ) : (
        <div className={errorMessage ? 'not-data error' : 'not-data'}>
          {errorMessage
            ? `Não foi possível carregar as vendas: ${errorMessage}`
            : isFetching
            ? 'Carregando vendas do período…'
            : 'Nenhuma venda no período selecionado.'}
        </div>
      )}
    </S.Container>
  );
}
